import { createFileRoute } from "@tanstack/react-router";
import { ActionPlanListPage } from "@features/action-plans/components/ActionPlanPage";
import { QueryErrorBoundary } from "@components/errors/QueryErrorBoundary";
import { LoadingIndicator } from "@ui/LoadingIndicator";
import { Suspense } from "react";

export const Route = createFileRoute("/_layout/_teacher-portal/action-plans")({
	component: RouteComponent,
	staticData: { crumb: { label: "Action Plans" } },
});

function RouteComponent() {
    return (
        <QueryErrorBoundary title='Failed to load action plans'>
            <Suspense fallback={<LoadingIndicator resource='action plans'/>}>
                <ActionPlanListPage/>
            </Suspense>
        </QueryErrorBoundary>
    )
}
